import { useEffect, useState } from 'react';

type UserInputType = 'keyboard' | 'mouse';

export const useActiveInput = () => {
  const [userActiveInput, setUserActiveInput] = useState<UserInputType>('mouse');

  useEffect(() => {
    const keyboardHandler = () => {
      setUserActiveInput('keyboard');
    };
    window.addEventListener('keydown', keyboardHandler);

    const mouseHandler = () => {
      setUserActiveInput('mouse');
    };
    window.addEventListener('mousedown', mouseHandler);

    return () => {
      window.removeEventListener('keypress', keyboardHandler);
      window.removeEventListener('mousedown', mouseHandler);
    };
  });

  return userActiveInput;
};
